var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 25.5L17.5 17.5M10.8333 14.8333V14.8467M1.5 10.8333C1.5 12.059 1.74141 13.2727 2.21046 14.405C2.6795 15.5374 3.36699 16.5663 4.23367 17.433C5.10035 18.2997 6.12925 18.9872 7.26162 19.4562C8.39399 19.9253 9.60766 20.1667 10.8333 20.1667C12.059 20.1667 13.2727 19.9253 14.405 19.4562C15.5374 18.9872 16.5663 18.2997 17.433 17.433C18.2997 16.5663 18.9872 15.5374 19.4562 14.405C19.9253 13.2727 20.1667 12.059 20.1667 10.8333C20.1667 9.60766 19.9253 8.39399 19.4562 7.26162C18.9872 6.12925 18.2997 5.10035 17.433 4.23367C16.5663 3.36699 15.5374 2.6795 14.405 2.21046C13.2727 1.74141 12.059 1.5 10.8333 1.5C9.60766 1.5 8.39399 1.74141 7.26162 2.21046C6.12925 2.6795 5.10035 3.36699 4.23367 4.23367C3.36699 5.10035 2.6795 6.12925 2.21046 7.26162C1.74141 8.39399 1.5 9.60766 1.5 10.8333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 10.8335C11.169 10.8337 11.4992 10.7494 11.7937 10.5884C12.0882 10.4274 12.3374 10.1949 12.5184 9.91235C12.6995 9.62976 12.8065 9.30615 12.8296 8.97135C12.8527 8.63654 12.7912 8.3013 12.6508 7.9965C12.5103 7.6917 12.2955 7.42714 12.0259 7.22719C11.7564 7.02725 11.4409 6.89835 11.1084 6.85236C10.776 6.80638 10.4373 6.84478 10.1236 6.96405C9.80991 7.08331 9.53127 7.2796 9.31335 7.53483",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.f529baaa4f0e7c97814fe00cb1f43a12.svg";
export { ForwardRef as ReactComponent };